import { CustomFieldInput } from "components/CustomFields/CustomFieldInput";
import React from "react";
import { useTranslate } from "react-admin";

import { FormGroupGrid, GridInput } from "../../../components/GridForm";

export const CustomFieldsBlock = ({ customFields, ...props }) => {
	const translate = useTranslate();
	if (!customFields?.length) return null;
	
	const disabled =  props.disabled || (props.enabledFields && !props.enabledFields[props.source]);

	return (
		<FormGroupGrid title={translate("resources.orders.block-label.custom-fields")} disabled={disabled}>
			{customFields.map((field, index) => (
				<GridInput xs={6} sm={4} md={3}>
					<CustomFieldInput
						fieldType={field.type}
						isFilter={false}
						key={`custom_${field.key}`}
						label={field.name}
						source={`custom_fields_values.${field.name}`}
						defaultValue={field.value}
					/>
				</GridInput>
			))}
		</FormGroupGrid>
	);
};
